<div *ngIf="getEmojiData()" class="emoji-wrapper">
  <div class="emoji-label fw-medium">{{ getEmojiData().label }}</div>
  <div class="emoji-circle">
    <img alt="Emoji icon" [src]="getEmojiData().icon" class="emoji-icon" />
  </div>
</div>
